// extracted by mini-css-extract-plugin
export default {"user":"styles_user__nCfIV","info":"styles_info__VKUh5","email":"styles_email__QrqSx"};